import React, { useState } from "react";
import { useFormikContext } from "formik";
import store from "../../../../../store/store";
import {
  FormDateField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import {
  CustomTextAreaField,
  CustomTextField,
} from "../../../../../partials/content/Forms";
import { Card } from "react-bootstrap";
import { DialogActions, IconButton, InputAdornment } from "@material-ui/core";
import { People, Search } from "@mui/icons-material";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchUser from "../../../users/users/searchUser";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";

function JourneyHead(props) {
  const { auth } = store.getState();
  const [openSearchUser, setOpenSearchUser] = useState(false);
  const { userID, fullName } = auth.user;
  const {
    setFieldValue,
    handleBlur,
    handleChange,
    values,
    touched,
    errors,
  } = useFormikContext();
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-window-maximize"></i>
              <span>
                <strong>Sales Journey Header</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormTextField label="Sales Journey Name" name="title" />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormDateField
                        name="planStartDate"
                        label="Plan Start Date"
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormDateField name="planEndDate" label="Plan End Date" />
                    </div>
                  </div>
                  <FormTextField
                    label="Assigned To"
                    name="salesName"
                    assignmeButton
                    searchButton
                    onAssignmeClick={() => {
                      setFieldValue("salesID", userID);
                      setFieldValue("salesName", fullName);
                    }}
                    onSearchClick={() => {
                      setOpenSearchUser(true);
                    }}
                    readonly
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormTextField
                    label="Description"
                    name="description"
                    multiline
                    minRows={7}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <DialogLayout
        open={openSearchUser}
        title="Search User"
        onCloseDialog={() => {
          setOpenSearchUser(false);
        }}
        maxWIdth="lg"
      >
        <SearchUser
          salesUser="true"
          onSelectUser={(user) => {
            setFieldValue(`salesID`, user.ID);
            setFieldValue(`salesName`, user.firstName + " " + user.lastName);
            setOpenSearchUser(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUser(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default JourneyHead;
